var _defs, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbuWebinarPhase3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 343.24 301.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .ibu-webinar-disable-rect{\n        fill: #edeef0;;\n      }\n      .ibu-webinar-disable-rect:hover {\n        pointer-events: none;\n        fill: #edeef0;;  \n      }\n\n      .cls-1-ibu-webinnar-p3 {\n        fill: #fff;\n        stroke: #3a414a;\n      }\n\n      .cls-2-ibu-webinnar-p3 {\n        stroke-width: .05px;\n      }\n\n      .cls-2-ibu-webinnar-p3, .cls-3-ibu-webinnar-p3 {\n        fill: #008573;\n      }\n\n      .cls-2-ibu-webinnar-p3, .cls-3-ibu-webinnar-p3, .cls-4-ibu-webinnar-p3 {\n        stroke: #008573;\n      }\n\n      .cls-5-ibu-webinnar-p3 {\n        fill: #3a414a;\n        stroke-width: 0px;\n      }\n\n      .cls-4-ibu-webinnar-p3 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ibu-webinar-disable-rect",
    d: "M.5,195.1c0-3.31,2.69-6,6-6h330.24c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.51c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "h",
    className: "cls-5-ibu-webinnar-p3",
    d: "M53.24,250.9v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    className: "cls-5-ibu-webinnar-p3",
    d: "M66.41,235.22v-2.04h2.17v2.04h-2.17ZM66.41,250.9v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    className: "cls-5-ibu-webinnar-p3",
    d: "M77.48,250.9h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    className: "cls-5-ibu-webinnar-p3",
    d: "M89.16,237.73c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM92.69,243.23c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "k-2",
    "data-name": "k",
    className: "cls-5-ibu-webinnar-p3",
    d: "M109.53,237.73c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM113.06,243.23c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j-2",
    "data-name": "j",
    className: "cls-5-ibu-webinnar-p3",
    d: "M123.65,250.9h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k-3",
    "data-name": "k",
    className: "cls-5-ibu-webinnar-p3",
    d: "M135.33,237.73c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM138.86,243.23c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    className: "cls-5-ibu-webinnar-p3",
    d: "M150.07,237.73c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    className: "cls-5-ibu-webinnar-p3",
    d: "M159.71,247.71c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m-2",
    "data-name": "m",
    className: "cls-5-ibu-webinnar-p3",
    d: "M173.29,247.71c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    className: "cls-5-ibu-webinnar-p3",
    d: "M185.65,248.46c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM179.33,247.31c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    className: "cls-5-ibu-webinnar-p3",
    d: "M199.36,250.9l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k-4",
    "data-name": "k",
    className: "cls-5-ibu-webinnar-p3",
    d: "M208.67,237.73c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM212.2,243.23c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    className: "cls-5-ibu-webinnar-p3",
    d: "M224.62,241.19c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "q",
    className: "cls-5-ibu-webinnar-p3",
    d: "M242.28,237.73c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM241.73,249.55c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    className: "cls-5-ibu-webinnar-p3",
    d: "M249.68,250.9v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n-2",
    "data-name": "n",
    className: "cls-5-ibu-webinnar-p3",
    d: "M262.99,248.46c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM256.67,247.31c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    className: "cls-5-ibu-webinnar-p3",
    d: "M273.51,239.43c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k-5",
    "data-name": "k",
    className: "cls-5-ibu-webinnar-p3",
    d: "M286.01,237.73c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM289.54,243.23c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-ibu-webinnar-p3",
    d: "M171.64,113.49v58.72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-ibu-webinnar-p3",
    d: "M172.14,113.51h-1v-.52h1v.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-ibu-webinnar-p3",
    d: "M171.64,186.97l-4.65-14.26h9.27l-4.62,14.26Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-ibu-webinnar-p3",
    d: "M.5,6.5C.5,3.19,3.19.5,6.5.5h330.24c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.51c-3.31,0-6-2.69-6-6V6.5Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    className: "cls-5-ibu-webinnar-p3",
    d: "M25.54,45.46c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM27.78,53.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "cls-5-ibu-webinnar-p3",
    d: "M46.59,49.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM46.52,60.94c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-2",
    "data-name": "r",
    className: "cls-5-ibu-webinnar-p3",
    d: "M55.01,62.3v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-3",
    "data-name": "r",
    className: "cls-5-ibu-webinnar-p3",
    d: "M60.37,62.3v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i-2",
    "data-name": "i",
    className: "cls-5-ibu-webinnar-p3",
    d: "M65.73,46.61v-2.04h2.17v2.04h-2.17ZM65.73,62.3v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l-2",
    "data-name": "l",
    className: "cls-5-ibu-webinnar-p3",
    d: "M77.41,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    className: "cls-5-ibu-webinnar-p3",
    d: "M95.07,49.4c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM89.43,60.81c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "w",
    className: "cls-5-ibu-webinnar-p3",
    d: "M113.27,60.2c-.75,1.49-1.97,2.38-4.07,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.01,1.15-6.72,4.75-6.79,2.17-.07,3.26.95,4.07,2.24,0-.75-.07-1.63.14-2.17h2.04l-.07,18.2h-2.17l.07-7.2ZM109.73,60.87c2.78,0,3.46-2.24,3.46-5.16s-.54-4.96-3.4-4.96-3.12,2.38-3.12,5.09.34,5.02,3.06,5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    className: "cls-5-ibu-webinnar-p3",
    d: "M122.7,62.57c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k-6",
    "data-name": "k",
    className: "cls-5-ibu-webinnar-p3",
    d: "M137.37,49.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM140.9,54.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p-2",
    "data-name": "p",
    className: "cls-5-ibu-webinnar-p3",
    d: "M153.33,52.59c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m-3",
    "data-name": "m",
    className: "cls-5-ibu-webinnar-p3",
    d: "M160.39,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i-3",
    "data-name": "i",
    className: "cls-5-ibu-webinnar-p3",
    d: "M164.8,46.61v-2.04h2.17v2.04h-2.17ZM164.8,62.3v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-2",
    "data-name": "u",
    className: "cls-5-ibu-webinnar-p3",
    d: "M175.33,49.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM175.26,60.94c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l-3",
    "data-name": "l",
    className: "cls-5-ibu-webinnar-p3",
    d: "M190.06,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p-3",
    "data-name": "p",
    className: "cls-5-ibu-webinnar-p3",
    d: "M204.86,52.59c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p-4",
    "data-name": "p",
    className: "cls-5-ibu-webinnar-p3",
    d: "M223.88,52.59c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-2",
    "data-name": "x",
    className: "cls-5-ibu-webinnar-p3",
    d: "M232.64,62.57c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "cls-5-ibu-webinnar-p3",
    d: "M248.32,49.13c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM247.78,60.94c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    className: "cls-5-ibu-webinnar-p3",
    d: "M268.35,50.82c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i-4",
    "data-name": "i",
    className: "cls-5-ibu-webinnar-p3",
    d: "M276.03,46.61v-2.04h2.17v2.04h-2.17ZM276.03,62.3v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m-4",
    "data-name": "m",
    className: "cls-5-ibu-webinnar-p3",
    d: "M283.77,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m-5",
    "data-name": "m",
    className: "cls-5-ibu-webinnar-p3",
    d: "M290.56,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k-7",
    "data-name": "k",
    className: "cls-5-ibu-webinnar-p3",
    d: "M300.13,49.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM303.66,54.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "cls-5-ibu-webinnar-p3",
    d: "M312.69,49.13c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM313.3,50.76c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbuWebinarPhase3);
export default __webpack_public_path__ + "static/media/IBU_Webinar_Phase_3.8e4b7b2b149b037b3d9107ee092ecfb0.svg";
export { ForwardRef as ReactComponent };